function DazMint(minter) {
    this.minter = minter;
    this.address = minter.address;
    this.initialized = false;
}

DazMint.prototype.init = async function() {
    const mResult = await this.minter.init();
    this.initialized = true;
    return mResult;
}

DazMint.prototype.mint = async function (data) {

    return this.minter.mint(data).then(primedData => {
        return this.minter.complete(primedData, this).then(trx => {
            window.dispatchEvent(new CustomEvent("mint_complete", {detail: {data: primedData, trx: trx}}));
            return trx;
        }, e => {
            console.error(e);
            window.dispatchEvent(new CustomEvent("mint_error", {
                detail: {
                    when: "complete",
                    data: primedData,
                    error: e
                }
            }));
        }).catch(e => {
            throw e;
        });
    }, e => {
        console.error(e);
        window.dispatchEvent(new CustomEvent("mint_error", {detail: {when: "mint", data: data, error: e}}));
        throw e;
    });
}

DazMint.prototype.onTransactionHash = function (data, hash) {
    window.dispatchEvent(new CustomEvent("mint_hash", {detail: {data, hash}}));
}
